<tr *ngFor="let x of rowsArray">
  <td *ngFor="let y of colsArray">
    <app-placeholder></app-placeholder>
  </td>
</tr>
